import React from 'react';
export function GridPattern({
  className = ''
}: {
  className?: string;
}) {
  return <svg className={className} aria-hidden="true" xmlns="http://www.w3.org/2000/svg" data-id="element-131">
      <defs data-id="element-132">
        <pattern id="grid" width="48" height="48" patternUnits="userSpaceOnUse" data-id="element-133">
          <path d="M 48 0 L 0 0 0 48" fill="none" stroke="currentColor" strokeWidth="0.5" data-id="element-134" />
        </pattern>
      </defs>
      <rect width="100%" height="100%" fill="url(#grid)" data-id="element-135" />
    </svg>;
}